import axiosInstance from '@/lib/axiosInstance';
import { listAiModule } from './data';
import { GetTokenOptionResponse } from './type';

export const getListAiModule = () => {
  return listAiModule;
};

export const getAIServiceToken = async (params: { workspace_id: string }) => {
  const { data } = await axiosInstance.post<GetTokenOptionResponse>(`/auth/init_saas_token`, params);
  return data;
};

export const regenerateAIServiceToken = async (params: {
  workspace_id: string;
}) => {
  const { data } = await axiosInstance.post(`/auth/regenerate_saas_token`, params);
  return data;
};